import AppLayout from '@components/layouts/appLayout';

import { StoryFooter } from '../components/layout/StoryFooter';
import { StoryHeader } from '../components/layout/StoryHeader';
import { StoryWrapper } from '../components/layout/StoryWrapper';
import VideoPlayer from '../components/video/VideoPlayer';
import { StoryPageDisplay, StoryPageType } from '../enums';
import { Renderer, Tester } from '../types';

export const renderer: Renderer = ({ story, storyPage }) => {
    return (
        <AppLayout
            hasFixedFooter
            footerHasPointerEvents={false}
            header={
                <StoryHeader
                    withExit={false}
                    story={story}
                    storyPage={storyPage}
                />
            }
            body={
                <StoryWrapper>
                    <VideoPlayer storyPage={storyPage} />
                </StoryWrapper>
            }
            footer={
                <StoryFooter
                    withCtas
                    withNavigationButtons
                    storyPage={storyPage}
                    withVideoPlayerButtons={true}
                />
            }
        />
    );
};

export const tester: Tester = (display, storyPage) => {
    return {
        condition:
            display === StoryPageDisplay.Flow &&
            storyPage.type === StoryPageType.Video &&
            !!storyPage.ctas,
        priority: 7,
    };
};

const rendererWithTester = { renderer, tester };

export default rendererWithTester;
